import has from "lodash/has";
import omit from "lodash/omit";

import Image from "next/image";

interface MultimediaProps {
  type: string;
  src: string;
  alt?: string;
  className: string,
  testId?: string;
  containerClass?: string;
  embedCode?: string;
  height?: number;
  width?: number;
  priority?: boolean;
  isNextImage?: boolean;
  noBlur?: boolean;
  lazyBoundary?: string;
}

const BLUR_DATA_URL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAQMAAAC6caSPAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAANQTFRF7vD13W0nXgAAACpJREFUeJztwTEBAAAAwqD1T+1vBqAAAAAAAAAAAAAAAAAAAAAAAAAAgDdPsAABORaXeAAAAABJRU5ErkJggg==";

const Multimedia = (props: MultimediaProps) => {
  const { type, src, alt, className, testId, priority=false, isNextImage=true, noBlur=false, lazyBoundary="200px" } = props
  let restProps = {};

  switch (type) {
    case "image": {
      restProps = omit(props, ["type", "lazy", "displayLoader", "loadingClass"]);
      if(!has(restProps, "width") || !has(restProps, "height"))
        restProps["layout"] = "fill";

      if(!src) return null
      if(!isNextImage)
        return <img
          src={src}
          alt={alt || src}
          className={`lazyload ${className}`}
          data-testid={testId}
          {...restProps}
        />

      return <Image
        src={src}
        alt={alt || src}
        className={`lazyload ${className}`}
        data-testid={testId}
        priority={priority}
        placeholder={noBlur ? "empty" : "blur"}
        blurDataURL={BLUR_DATA_URL}
        {...restProps}
      />
    }

    case "video": {
      restProps = omit(props, ["type", "lazy", "src", "className"]);
      return (
        <video className={`lazyload ${props.className}`} data-testid={testId} {...restProps} >
          <source src={src} />
        </video>
      );
    }

    case "iframe": {
      restProps = omit(props, ["type", "lazy", "className"]);
      return <iframe className={`lazyload ${props.className}`} data-testid={testId} {...restProps} />;
    }

    default:
      return <></>;
  }
}

export default Multimedia